module.exports = __webpack_public_path__ + "static/media/2_AP_Moderate_Z2.1e85b678.png";